import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandS } from '@sorare/core/src/atoms/typography';
import { Trapezoid } from '@sorare/core/src/atoms/ui/Trapezoid';
import { fantasy } from '@sorare/core/src/lib/glossary';

import replayIcon from './assets/replayIcon.webp';

const StyledHorizontal = styled(Horizontal)`
  color: var(--c-black);
`;
const Img = styled.img`
  width: var(--double-and-a-half-unit);
  height: var(--double-and-a-half-unit);
  object-fit: contain;
`;

export const ReplayTitle = () => {
  return (
    <Trapezoid
      style={{ '--background': 'var(--c-rewards-yellow)' } as CSSProperties}
    >
      <StyledHorizontal center gap={0.5}>
        <Img src={replayIcon} alt="" />
        <BrandS color="var(--c-black)">
          <FormattedMessage {...fantasy.replay} />
        </BrandS>
      </StyledHorizontal>
    </Trapezoid>
  );
};
